import React from 'react';
import PropTypes from 'prop-types';

export default function Handle({ style, handleRef, ...passProps }) {
  return (
    <div
      ref={handleRef}
      {...passProps}
      style={{
        ...style,
        cursor: 'ew-resize',
        marginLeft: -50,
        marginTop: -43,
        padding: '30px',
        zIndex: 3,
        userSelect: 'none'
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          border: '1px solid #000f89',
          borderRadius: '100%',
          height: 25,
          width: 25,
          marginLeft: '7px',
          marginTop: '7px'
          // userSelect: 'none'
        }}
      />
    </div>
  );
}
Handle.propTypes = {
  style: PropTypes.object,
  handleRef: PropTypes.any
};
Handle.defaultProps = {
  style: null,
  handleRef: ''
};
